/* ==== MM / Hero slider — JS ============================================== */
(function () {
  'use strict';

  function initHero(hero) {
    var bgs = hero.querySelectorAll('.mm-hero__slide-bg');
    var contents = JSON.parse(hero.querySelector('[data-hero-slides]').textContent);
    var titleEl = hero.querySelector('.mm-hero__title');
    var subEl = hero.querySelector('.mm-hero__subtitle');
    var ratingEl = hero.querySelector('.mm-hero__rating');
    var ctaRow = hero.querySelector('.mm-hero__cta-row');
    var current = 0;
    var autoplay = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var paused = false;

    /* reporte la couleur de contenu du slide (foncé / blanc) sur .mm-hero :
       pilote titre, sous-titre, CTA, anneau, puces (cf. mm-hero {% stylesheet %}) */
    function applyContentColor(index) {
      var tone = (contents[index] && contents[index].content) || 'dark';
      hero.classList.toggle('mm-hero--content-light', tone === 'light');
      hero.classList.toggle('mm-hero--content-dark', tone !== 'light');
    }

    /* lance la vidéo du slide actif, met les autres en pause (autoplay muet en boucle) */
    function applyVideo(index) {
      bgs.forEach(function (bg, i) {
        bg.querySelectorAll('.mm-hero__slide-video video').forEach(function (video) {
          if (i === index && video.offsetParent !== null) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      });
    }
    window.matchMedia('(width <= ' + window.MOBILE_BREAKPOINT + 'px)').addEventListener('change', function () {
      applyVideo(current);
    });

    function applyHeaderTone(index) {
      hero.setAttribute('data-header-tone', (contents[index] && contents[index].header) || 'light');
    }

    /* affiche / masque la pill de notation selon le slide (block show_rating) */
    function applyRating(index) {
      if (!ratingEl) return;
      var show = !contents[index] || contents[index].rating !== false;
      ratingEl.classList.toggle('is-rating-hidden', !show);
    }

    /* met à jour le texte + le lien du CTA selon le slide (block cta_label / cta_url) */
    function applyCta(index) {
      if (!ctaRow) return;
      var cta = contents[index] && contents[index].cta;
      var show = cta ? cta.show !== false : false;
      ctaRow.classList.toggle('is-cta-hidden', !show);
      if (!show || !cta) return;
      var link = ctaRow.querySelector('.mm-btn, .mm-link');
      if (!link) return;
      if (link.tagName === 'A') link.setAttribute('href', cta.url);
      var textEl = link.querySelector('.mm-btn__text');
      if (textEl) textEl.textContent = cta.label;
      else link.textContent = cta.label;
    }

    /* découpe le titre en mots pour l'animation en cascade */
    function splitTitle(text) {
      titleEl.innerHTML = '';
      text.split(' ').forEach(function (word, i) {
        var outer = document.createElement('span');
        outer.className = 'mm-hero__word';
        var inner = document.createElement('span');
        inner.textContent = word;
        inner.style.setProperty('--w', i);
        outer.appendChild(inner);
        titleEl.appendChild(outer);
        titleEl.appendChild(document.createTextNode(' '));
      });
    }

    function afterLoad(callback) {
      if (document.readyState === 'complete') callback();
      else window.addEventListener('load', callback, { once: true });
    }

    function loadSlides() {
      hero.classList.add('is-slides-loaded');
    }
    afterLoad(loadSlides);

    function goTo(index) {
      if (bgs.length < 2 && hero.classList.contains('is-in')) return;
      loadSlides();
      current = (index + contents.length) % contents.length;

      /* 1. sortie douce du contenu (les flèches restent) */
      hero.classList.add('is-switching');
      hero.classList.remove('is-in');

      window.setTimeout(function () {
        /* 2. swap fond + textes */
        bgs.forEach(function (bg, i) {
          bg.classList.toggle('is-active', i === current);
        });
        splitTitle(contents[current].title);
        if (contents[current].subtitle) subEl.textContent = contents[current].subtitle;
        applyContentColor(current);
        applyHeaderTone(current);
        applyRating(current);
        applyCta(current);
        applyVideo(current);

        /* 3. ré-entrée spring orchestrée */
        hero.classList.remove('is-switching');
        void hero.offsetWidth;
        hero.classList.add('is-in');
      }, 230);

      /* bullets mobiles synchronisées */
      hero.querySelectorAll('[data-hero-dot]').forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        if (i === current) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    /* boucle autoplay : relance l'anneau de progression (rendu par le
       COMPOSANT mm-slider-controls via slider_autoplay) à chaque cycle */
    function schedule() {
      if (!autoplay || paused || reduceMotion.matches) return;
      window.clearTimeout(timer);
      hero.classList.remove('is-cycling');
      void hero.offsetWidth; /* redémarre l'animation de l'anneau */
      hero.classList.add('is-cycling');
      timer = window.setTimeout(function () {
        goTo(current + 1);
        schedule();
      }, autoplay * 1000);
    }

    /* événements émis par le COMPOSANT mm-slider-controls (relais data-slider-target) */
    function pause() {
      paused = true;
      window.clearTimeout(timer);
      hero.classList.remove('is-cycling');
    }
    function resume() {
      if (!paused) return;
      paused = false;
      schedule();
    }
    hero.addEventListener('mouseenter', pause);
    hero.addEventListener('focusin', pause);
    hero.addEventListener('mouseleave', function () {
      if (!hero.contains(document.activeElement)) resume();
    });
    hero.addEventListener('focusout', function (e) {
      if (!hero.contains(e.relatedTarget) && !hero.matches(':hover')) resume();
    });

    hero.addEventListener('mm:slider:next', function () { goTo(current + 1); schedule(); });
    hero.addEventListener('mm:slider:prev', function () { goTo(current - 1); schedule(); });

    /* bullets mobiles : saut direct + anneau relancé */
    hero.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-hero-dot]');
      if (dot) { goTo(parseInt(dot.getAttribute('data-hero-dot'), 10)); schedule(); }
    });

    /* réassurance : rotation douce — en mobile un seul item est visible
       (slider auto), en desktop la grille montre tout (classe sans effet) */
    var rItems = hero.querySelectorAll('.mm-hero__reassurance .mm-hero__item');
    if (rItems.length > 1 && !reduceMotion.matches) {
      var rIndex = 0;
      rItems[0].classList.add('is-reassure-active');
      window.setInterval(function () {
        rItems[rIndex].classList.remove('is-reassure-active');
        rIndex = (rIndex + 1) % rItems.length;
        rItems[rIndex].classList.add('is-reassure-active');
      }, 4000);
    }

    /* première entrée quand le hero devient visible */
    splitTitle(contents[0].title);
    applyContentColor(0);
    applyRating(0);
    applyCta(0);
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        hero.classList.add('is-in');
        afterLoad(function () { applyVideo(current); });
        /* les flèches ne rejouent plus leur entrée ensuite */
        window.setTimeout(function () { hero.classList.add('is-ready'); }, 1200);
        schedule();
        io.disconnect();
      }
    }, { threshold: 0.3 });
    io.observe(hero);
  }

  document.querySelectorAll('.mm-hero').forEach(initHero);
})();
